/**
 * * Модель, описывающая пользователя
 */
export class TaskPersonModel {
  /** Id */
  Id: number;
  /** Имя */
  FirstName: string;
  /**  Фамилия */
  LastName: string;
  /** Отчетсво */
  MiddleName: string;
  /** Аватарка */
  ImageUrl: string;
  /** Цвет фона, если нет аватарки */
  NoPhotoColor: string;

  constructor(obj?: Partial<TaskPersonModel>) {
    Object.assign(this, obj);
  }
}
